import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { isDevMode } from '@angular/core';
import { provideTransloco } from '@jsverse/transloco';
import { provideTranslocoLocale } from '@jsverse/transloco-locale';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';

import { TranslocoHttpLoader } from '@customer-portal/i18n';

registerLocaleData(localeNl);

export function provideTranslation() {
  return [
    provideTransloco({
      config: {
        availableLangs: ['nl-NL'],
        defaultLang: 'nl-NL',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoMessageformat(),
    provideTranslocoLocale({
      defaultCurrency: 'EUR',
      localeConfig: {
        global: {
          currency: {
            currency: 'EUR',
          },
        },
      },
    }),
  ];
}
